import Accompaniements from '../components/pages/Accompaniements.vue'
import Categories from '../components/pages/Categories.vue'
import Ads from '../components/pages/Ads.vue'
import Clients from '../components/pages/Clients.vue'
import Coupons from '../components/pages/Coupons.vue'
import Dashboard from '../components/pages/Dashboard.vue'
import Deals from '../components/pages/Deals.vue'
import DeliveryZone from '../components/pages/DeliveryZone.vue'
import Dishes from '../components/pages/Dishes.vue'
import Drinks from '../components/pages/Drinks.vue'
import Fees from '../components/pages/Fees.vue'
import Kyc from '../components/pages/Kyc.vue'
import Milestones from '../components/pages/Milestones.vue'
import Notifications from '../components/pages/Notifications.vue'
import Orders from '../components/pages/Orders.vue'
import Packages from '../components/pages/Packages.vue'
import Permissions from '../components/pages/Permissions.vue'
import Restaurants from '../components/pages/Restaurants.vue'
import Riders from '../components/pages/Riders.vue'
import Sales from '../components/pages/Sales.vue'
import Settings from '../components/pages/Settings.vue'
import Tickets from '../components/pages/Tickets.vue'
import Transactions from '../components/pages/Transactions.vue'
import Withdrawals from '../components/pages/Withdrawals.vue'
import Promotions from '../components/pages/Promotions.vue'
import ProductsList from '../components/pages/ProductsList.vue'
import ProductPurchasesList from '../components/pages/ProductPurchasesList.vue'
import ClientDebtsList from '../components/pages/ClientDebtsList.vue'
import authRoutesMap from './auth/authRoutesMap'

export default {
  ...authRoutesMap,
  dashboard: {
    route: '/',
    name: 'dashboard',
    title: 'dashboard',
    component: Dashboard,
    layoutName: 'app',
    checkAuth: true,
    needAuth: true,
    permission: 'dashboard',
  },
  restaurants: {
    route: '/restaurants',
    name: 'restaurants',
    title: 'restaurants',
    layoutName: 'app',
    component: Restaurants,
    checkAuth: true,
    needAuth: true,
    permission: 'restaurants',
  },
  customers: {
    route: '/customers',
    name: 'customers',
    title: 'customers',
    layoutName: 'app',
    component: Clients,
    checkAuth: true,
    needAuth: true,
    permission: 'customers',
  },
  milestoness: {
    route: '/milestones',
    name: 'milestones',
    title: 'milestones',
    layoutName: 'app',
    component: Milestones,
    checkAuth: true,
    needAuth: true,
    permission: 'milestones',
  },
  deliveryZone: {
    route: '/deliveryZone',
    name: 'deliveryZone',
    title: 'deliveryZone',
    layoutName: 'app',
    component: DeliveryZone,
    checkAuth: true,
    needAuth: true,
    permission: 'deliveries',
  },
  accompaniements: {
    route: '/accompaniements',
    name: 'accompaniements',
    title: 'accompaniements',
    layoutName: 'app',
    component: Accompaniements,
    checkAuth: true,
    needAuth: true,
    permission: 'restaurants',
  },
  categories: {
    route: '/categories',
    name: 'categories',
    title: 'categories',
    layoutName: 'app',
    component: Categories,
    checkAuth: true,
    needAuth: true,
    permission: 'restaurants',
  },
  drinks: {
    route: '/drinks',
    name: 'drinks',
    title: 'drinks',
    layoutName: 'app',
    component: Drinks,
    checkAuth: true,
    needAuth: true,
    permission: 'restaurants',
  },
  dishes: {
    route: '/dishes',
    name: 'dishes',
    title: 'dishes',
    layoutName: 'app',
    component: Dishes,
    checkAuth: true,
    needAuth: true,
    permission: 'restaurants',
  },
  sales: {
    route: '/sales',
    name: 'sales',
    title: 'sales',
    layoutName: 'app',
    component: Sales,
    checkAuth: true,
    needAuth: true,
    permission: 'finance',
  },
  notification: {
    route: '/notification',
    name: 'notification',
    title: 'notification',
    layoutName: 'app',
    component: Notifications,
    checkAuth: true,
    needAuth: true,
    permission: 'marketing',
  },
  tickets: {
    route: '/tickets',
    name: 'tickets',
    title: 'tickets',
    layoutName: 'app',
    component: Tickets,
    checkAuth: true,
    needAuth: true,
    permission: 'marketing',
  },
  coupons: {
    route: '/coupons',
    name: 'coupons',
    title: 'coupons',
    layoutName: 'app',
    component: Coupons,
    checkAuth: true,
    needAuth: true,
    permission: 'marketing',
  },
  deals: {
    route: '/deals',
    name: 'deals',
    title: 'deals',
    layoutName: 'app',
    component: Deals,
    checkAuth: true,
    needAuth: true,
    permission: 'marketing',
  },
  packages: {
    route: '/packages',
    name: 'packages',
    title: 'packages',
    layoutName: 'app',
    component: Packages,
    checkAuth: true,
    needAuth: true,
    permission: 'orders',
  },
  riders: {
    route: '/riders',
    name: 'riders',
    title: 'riders',
    layoutName: 'app',
    component: Riders,
    checkAuth: true,
    needAuth: true,
    permission: 'riders',
  },
  ads: {
    route: '/ads',
    name: 'ads',
    title: 'ads',
    layoutName: 'app',
    component: Ads,
    checkAuth: true,
    needAuth: true,
    permission: 'marketing',
  },
  fees: {
    route: '/fees',
    name: 'fees',
    title: 'fees',
    layoutName: 'app',
    component: Fees,
    checkAuth: true,
    needAuth: true,
    permission: 'settings',
  },
  orders: {
    route: '/orders',
    name: 'orders',
    title: 'orders',
    layoutName: 'app',
    component: Orders,
    checkAuth: true,
    needAuth: true,
    permission: 'orders',
  },
  team: {
    route: '/team',
    name: 'team',
    title: 'team',
    layoutName: 'app',
    component: Permissions,
    checkAuth: true,
    needAuth: true,
    permission: 'team-members',
  },
  kyc: {
    route: '/kyc',
    name: 'kyc',
    title: 'kyc',
    layoutName: 'app',
    component: Kyc,
    checkAuth: true,
    needAuth: true,
    permission: 'kyc',
  },
  profile: {
    route: '/profile',
    name: 'profile',
    title: 'profile',
    layoutName: 'app',
    component: Settings,
    checkAuth: true,
    needAuth: true,
    // profile: always accessible to any authenticated admin, no permission required
  },
  transactions: {
    route: '/transactions',
    name: 'transactions',
    title: 'transactions',
    layoutName: 'app',
    component: Transactions,
    checkAuth: true,
    needAuth: true,
    permission: 'finance',
  },
  withdrawals: {
    route: '/withdrawals',
    name: 'withdrawals',
    title: 'withdrawals',
    layoutName: 'app',
    component: Withdrawals,
    checkAuth: true,
    needAuth: true,
    permission: 'finance',
  },
  promotions: {
    route: '/promotions',
    name: 'promotions',
    title: 'promotions',
    layoutName: 'app',
    component: Promotions,
    checkAuth: true,
    needAuth: true,
    permission: 'marketing',
  },
  adminProducts: {
    route: '/products',
    name: 'adminProducts',
    title: 'products',
    layoutName: 'app',
    component: ProductsList,
    checkAuth: true,
    needAuth: true,
    permission: 'adminProducts',
  },
  adminProductPurchases: {
    route: '/product-purchases',
    name: 'adminProductPurchases',
    title: 'productPurchases',
    layoutName: 'app',
    component: ProductPurchasesList,
    checkAuth: true,
    needAuth: true,
    permission: 'adminProducts',
  },
  clientDebts: {
    route: '/client-debts',
    name: 'clientDebts',
    title: 'clientDebts',
    layoutName: 'app',
    component: ClientDebtsList,
    checkAuth: true,
    needAuth: true,
    permission: 'debts',
  },
}
